// src/tokens/fontWeight.ts
var fontWeightRegular = 400;
var fontWeightMedium = 500;
var fontWeightBold = 700;
export { fontWeightRegular, fontWeightMedium, fontWeightBold };